import React from 'react';
import Feature from './feature';
import i18n from 'src/utils/translate';
import config from 'config/config';

const FeatureList = () => {
  const features = [
    {
      id: 'scope',
      iconPath: `${config.cdn.static}img/home/homepageicons-03.png`,
      name: i18n.t('Take control of your health'),
      description: i18n.t('We cover over 300+ conditions and wellbeing interests, so you can treat your health holistically.'),
    },
    {
      id: 'community',
      iconPath: `${config.cdn.static}img/home/homepageicons-01.png`,
      name: i18n.t('Connect with people like you'),
      description: i18n.t('People visit our platform everyday to connect with others who are going through similar health challenges.'),
    },
    {
      id: 'features',
      iconPath: `${config.cdn.static}img/home/homepageicons-02.png`,
      name: i18n.t('Get online support 24/7'),
      description: i18n.t('With access to resources, e-learning and experts you’ll learn about the interests that are relevant to your health.'),
    },
  ];

  return (
    <div className="home__features">
      {features.map(feature => (
        <Feature
          key={feature.id}
          {...feature}
        />
      ))}
    </div>
  );
};

export default FeatureList;
